<app-programtitle title="Matrix multiplication"></app-programtitle>
<p> Write a program multiply two matrices</p>

<app-editor code="{{program}}"> </app-editor>